import { ControllerContract } from '../architecture/ControllerContract';
import { getProductByProductId } from '../models/product/GetProductByProductId';
import { productSearchByText } from '../models/product/ProductSearchByText';
import { productSearchByTextRefinement } from '../models/product/ProductSearchByTextRefinement';
import { productSearchCombinations } from '../models/product/ProductSearchCombinations';
import { productSearchCombinationsByImage } from '../models/product/ProductSearchCombinationsByImage';
import { productSearchCombinationsByImageRefinement } from '../models/product/ProductSearchCombinationsByImageRefinement';
import { productSearchCombinationsRefinement } from '../models/product/ProductSearchCombinationsRefinement';
import { productSearchSimilar } from '../models/product/ProductSearchSimilar';
import { productSearchSimilarByImage } from '../models/product/ProductSearchSimilarByImage';
import { productSearchSimilarByImageRefinement } from '../models/product/ProductSearchSimilarByImageRefinement';
import { productSearchSimilarRefinement } from '../models/product/ProductSearchSimilarRefinement';
import { productSearchNew } from '../models/product/ProductSearchNew';
import { productSearchNewRefinement } from '../models/product/ProductSearchNewRefinement';
import { productSearchComplementaryCategory } from '../models/product/ProductSearchComplementaryCategory';
import { productSearchComplementaryCategoryRefinement } from '../models/product/ProductSearchComplementaryCategoryRefinement';
import { productGetSuggested } from '../models/product/ProductGetSuggested';

export const productRoutes = {
    controllerPath: 'product',
    endpoints: {
        getProductByProductId,
        productSearchByText,
        productSearchByTextRefinement,
        productSearchSimilarByImage,
        productSearchSimilarByImageRefinement,
        productSearchCombinationsByImage,
        productSearchCombinationsByImageRefinement,
        productSearchSimilar,
        productSearchSimilarRefinement,
        productSearchCombinations,
        productSearchCombinationsRefinement,
        productSearchComplementaryCategory,
        productSearchComplementaryCategoryRefinement,
        productSearchNew,
        productSearchNewRefinement,
        productGetSuggested
    }
} as const satisfies ControllerContract;

export type ProductRoutes = typeof productRoutes;
